import { Fragment } from 'react/jsx-runtime'
import { Outlet } from 'react-router-dom'

import { PageHeader } from '@/components/common/navigation/PageHeader'

export default function Component() {
  return (
    <Fragment>
      <PageHeader
        title="Chamado"
        canReturn
        items={[
          { title: 'Detalhes', path: 'detalhes' },
          { title: 'Técnico', path: 'tecnico' },
          { title: 'Produtos', path: 'produtos' },
        ]}
      />

      <Outlet />
    </Fragment>
  )
}
